import React, { useEffect, useState } from 'react';
import Layout from '../../components/global/layout';
import methodModel from '../../methods/methods';
import { useParams } from 'react-router-dom';
import ApiClient from '../../methods/api/apiClient';
import loader from '../../methods/loader';
import { toast } from 'react-toastify';

const Menu = () => {
    const { id } = useParams();
    const [menuItems, setMenuItems] = useState(methodModel?.initialMenuItems);
    const [UpdatedDate, setUpdatedDate] = useState({});

    const handleChange = (index, field, value) => {
        const updatedItems = [...menuItems];
        updatedItems[index] = { ...updatedItems[index], [field]: value };
        setMenuItems(updatedItems);
    };

    const handleAdd = () => {
        setMenuItems([...menuItems, { name: '', url: '', order_number: '' }]);
    };

    const handleRemove = (index) => {
        const updatedItems = menuItems.filter((_, i) => i !== index);
        setMenuItems(updatedItems);
    };

    const hasDuplicateOrderNumbers = (items) => {
        const orderNumbers = items.map(item => String(item?.order_number));
        const uniqueOrderNumbers = new Set(orderNumbers);
        return orderNumbers.length !== uniqueOrderNumbers.size;
    };


    const handleSubmit = (e) => {
        e.preventDefault();

        if (hasDuplicateOrderNumbers(menuItems)) {
            toast.error('Duplicate order numbers are not allowed.');
            return;
        }

        let method = 'put';
        let url = 'items';
        let value = {
            menu_items: menuItems,
            id: 53,
        };

        if (id) {
            method = 'put';
            url = 'items';
            value.id = JSON.parse(id);
        }
        loader(true);
        ApiClient.allApi(url, value, method).then((res) => {
            if (res.success) {
                toast.success(res?.message);
                Getdata();
            }
            loader(false);
        });
    };

    const Getdata = () => {
        loader(true);
        ApiClient.get('items?id=53').then((res) => {
            if (res.success) {
                const menuItems = res?.data?.menu_items || [];
                setMenuItems(menuItems);
                loader(false);
            }
        });
    };

    useEffect(() => {
        Getdata();
    }, []);

    return (
        <>
            <Layout>
                <div className="pprofile1 shadow-lg">
                    <div className="flex items-center mb-8">
                        <div>
                            <h3 className="text-2xl font-semibold text-[#111827]">
                                Menu Items
                            </h3>
                        </div>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="space-y-4">
                            {menuItems.map((item, index) => (
                                <div key={index} className="p-4 border rounded bg-gray-50">
                                    <div className="flex justify-between items-center mb-2">
                                        <h2 className="text-xl font-medium">Item {index + 1}</h2>
                                        {/* <button
                                            type="button"
                                            className="text-red-500 hover:text-red-700"
                                            onClick={() => handleRemove(index)}
                                        >
                                            Remove
                                        </button> */}
                                    </div>
                                    <div className="mb-4">
                                        <label htmlFor={`order_number${index}`} className="block text-sm font-medium text-gray-700">Order<span className='star'>*</span></label>
                                        <input
                                            id={`order_number${index}`}
                                            type="number"
                                            value={item.order_number}
                                            required
                                            onWheel={(e) => e.currentTarget.blur()}
                                            onChange={(e) => handleChange(index, 'order_number', e.target.value)}
                                            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                                        />
                                    </div>
                                    <div className="mb-4">
                                        <label htmlFor={`name${index}`} className="block text-sm font-medium text-gray-700">Name<span className='star'>*</span></label>
                                        <input
                                            id={`name${index}`}
                                            type="text"
                                            required
                                            value={item.name}
                                            onChange={(e) => handleChange(index, 'name', e.target.value)}
                                            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                                        />
                                    </div>
                                    <div className="mb-4">
                                        <label htmlFor={`url${index}`} className="block text-sm font-medium text-gray-700">URL<span className='star'>*</span></label>
                                        <input
                                            id={`url${index}`}
                                            type="text"
                                            required
                                            value={item.url}
                                            onChange={(e) => handleChange(index, 'url', e.target.value)}
                                            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                        {/* <button
                            type="button"
                            onClick={handleAdd}
                            className="mt-4 bg-blue-500 text-white px-4 py-2 rounded shadow hover:bg-blue-600"
                        >
                            Add Menu Item
                        </button> */}
                        <div className="flex justify-end gap-3 mt-5">
                            <button
                                type="submit"
                                className="inline-block cursor-pointer text-white bg-[#A12238] focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center mb-2"
                            >
                                Save
                            </button>
                        </div>
                    </form>
                </div>
            </Layout>
        </>
    );
};

export default Menu;
